

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NavigationLink extends Vue {
  @Prop()
  private readonly to!: string;

  @Prop({ default: false })
  private readonly external!: boolean;

  @Prop({ default: true })
  private readonly externalNewWindow!: boolean;

  @Prop({ default: false })
  private readonly clickable!: boolean;

  @Prop()
  private readonly icon!: string;
}
